import React, { useMemo } from "react";
import { TrainingCell } from "../TrainingCell/TrainingDay";
import HorseCell from "../HorseCell/HorseCell";

const TappingView = ({ filteredHorses = [], trainings = [], date }) => {
  // Filter only stallions (assuming Gender "3" represents stallions)
  const horses = useMemo(() => {
    return (filteredHorses || []).filter((horse) => horse.Gender === "3");
  }, [filteredHorses]);

  // Build an array of objects { task, horse } for each training
  const data = useMemo(() => {
    return trainings
      .map((training) => {
        const horse = horses.find((h) => h.id == training.horseid);
        if (!horse) return null; // Skip if horse not found
        return { task: training, horse };
      })
      .filter(Boolean); // Filter out null values
  }, [trainings, horses]);

  if (horses.length === 0) {
    return <div>No Stallions found</div>;
  }

  return (
    <div>
      <table className="riderTableR" style={{ width: "100%" }}>
        <thead>
          <tr>
            <td>{window.lang.horse}</td>
            <td>{window.lang.task}</td>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={`${item.task.id}&${item.horse.id}`}>
              <td style={{ textAlign: "left" }}>
                <HorseCell horse={item.horse} />
              </td>
              <td style={{ minWidth: "60px" }}>
                <TrainingCell
                  multipleOnSameColumn={false}
                  key={item.task.id}
                  training={item.task}
                  horse={item.horse}
                  date={date}
                  showHorseName={false}
                  holdEnabled={true}
                  setTimeOnFirstHold={true}
                  draggable={false}
                />
              </td>
            </tr>
          ))}
          <tr>
            <td style={{ textAlign: "left" }}>
              {/* Optionally add any additional content here */}
            </td>
            <td style={{ minWidth: "60px" }}>
              <TrainingCell
                fromTappingView={true}
                horse={horses[0]}
                multipleOnSameColumn={false}
                training={null}
                date={date}
                showHorseName={false}
                holdEnabled={true}
                setTimeOnFirstHold={true}
                draggable={false}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TappingView;
